import Chat from "../../components/employeer/chat";

const ChatEmployeerPage = () => {
  return <Chat />;
};

export default ChatEmployeerPage;
